import links from "@/links/links";

export default {
  actions: {
    GET_BY_USER_ID(userId) {
      return this.get(links.CONTACT_GET_BY_USER_ID(userId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.CONTACT_GET(id));
    },
  },
};
